const fetchPage = async () => {
  try {
    const response = await fetch(window.location.pathname);
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const text = await response.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    if(html.querySelector('.cart__item')) {
      document.querySelector('.wrap-cart').classList.remove('hidden')
      document.querySelector('.empty-cart').classList.add('hidden')
    } else {
      document.querySelector('.wrap-cart').classList.add('hidden')
      document.querySelector('.empty-cart').classList.remove('hidden')
    }
    
    if(html.querySelector('.cart__item')) {
      document.querySelector('.js-cart-items').innerHTML = html.querySelector('.js-cart-items').innerHTML
      document.querySelectorAll('.dtc-free-shipping-progress').forEach(element => {
        element.innerHTML = html.querySelector('.dtc-free-shipping-progress').innerHTML
      });
      document.querySelector('.js-cart-items-mobile').innerHTML = html.querySelector('.js-cart-items-mobile').innerHTML
      document.querySelectorAll('.subtotal-content__container .js-cart_subtotal').forEach(element => {
        element.innerHTML = html.querySelector('.subtotal-content__container .js-cart_subtotal').innerHTML
      });
      document.querySelector('.cart_count').innerHTML = html.querySelector('.cart_count').innerHTML
      document.querySelectorAll('.subtotal-container .js-upsell-container:not(.dtc-experiment-cart-upsell)').forEach(item => {
        item.innerHTML = html.querySelector('.subtotal-container .js-upsell-container:not(.dtc-experiment-cart-upsell)').innerHTML
      })
      document.querySelectorAll('.subtotal-container .js-upsell-container.dtc-experiment-cart-upsell').forEach(item => {
        item.innerHTML = html.querySelector('.subtotal-container .js-upsell-container.dtc-experiment-cart-upsell').innerHTML
      })
      document.querySelectorAll('.subtotals-cart').innerHTML = html.querySelector('.cart_subtotal').innerHTML
    }
    document.dispatchEvent(new Event('cart:reloaded'));
  } catch (error) {
    console.error(`Could not get products: ${error}`);
  }
}
document.querySelectorAll('.productItem__add-to-cart-button').forEach(item => {
  item.addEventListener('click', async (e) => {
    console.log('Add to cart button clicked:', e.target);
    const formData = {
      items: [
        {
          id: e.target.dataset.id,
          quantity: 1,
        },
      ],
    };

    const res = await fetch('/cart/add', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })

    const dataPrice = parseFloat(e.target.dataset.priceTotal.replace('$', '')); // Example: data-price="$60.00" => 60.00
    const dataQuantity = Number(e.target.dataset.dtcQuanty); // Example: data-dtc-quanty="1" => 1
    const dataVariantId = e.target.dataset.variantId; // Example: data-variant-id="1234567890" => "1234567890"
    const dataProductId = e.target.dataset.productId; // Example: data-product-id="1234567890" => "1234567890"
    const dataProductTitle = e.target.dataset.productTitle; // Example: data-product-title="Product Name" => "Product Name"
    const dataProductType = e.target.dataset.productType; // Example: data-product-type="Product Type" => "Product Type"
    const dataProductVendor = e.target.dataset.productVendor; // Example: data-product-vendor="Vendor Name" => "Vendor Name"

    const data = {
      price: dataPrice,
      quantity: dataQuantity,
      variantId: dataVariantId,
      productId: dataProductId,
      productName: dataProductTitle,
      productType: dataProductType,
      productVendor: dataProductVendor
    }

    if(res.ok) trackAddToCartEvent(data)

    fetchPage()
  })
})

document.addEventListener('click', async (e) => {
  if(e.target.classList.contains('cart-upsell__btn')) {
    const formData = {
      items: [
        {
          id: e.target.previousElementSibling.value,
          quantity: 1,
        },
      ],
    };

    await fetch('/cart/add', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })

    fetchPage()
  }
})

function trackAddToCartEvent(data) {
  console.info('Tracking Add to Cart Event:', data);
  MAI.emit('addToCart', data.price, "USD", data.quantity, {
    productId: data.productId,
    productName: data.productName,
    productType: data.productType,
    productVendor: data.productVendor,
    variantId: data.variantId,
    variantName: data.variantName
  }) 
}